import React from "react";

import InfoPanel from "./InfoPanel";
import GameTube from "./GameTube";
// import Logo from "./Logo";

const Header = ({ gameID, time, isGameProccess, viewedNumbers, startGame }) => {
  return (
    <div className="header">
      <InfoPanel
        round={gameID}
        startGame={startGame}
        time={time}
        isGameProccess={isGameProccess}
      />
      <GameTube viewedNumbers={viewedNumbers} />
    </div>
  );
};
export default Header;
